import { render, staticRenderFns } from "./CardPub.vue?vue&type=template&id=19aaff62&scoped=true"
import script from "./CardPub.vue?vue&type=script&lang=js"
export * from "./CardPub.vue?vue&type=script&lang=js"
import style0 from "./CardPub.vue?vue&type=style&index=0&id=19aaff62&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19aaff62",
  null
  
)

export default component.exports